module.exports = __webpack_public_path__ + "media/images/lp_seiho/sec02_img_03-dff1920c6e7f9fb3251e438a0cac6575.png";